module.exports = __webpack_public_path__ + "img/logo.b71b909f.png";